module.exports = __webpack_public_path__ + "img/tyres.08ae49ba.svg";